import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "constants/variables";

export const Summary = styled.dl<{ $columns: number }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => $columns === 2 ? "minmax(0, 1.35fr) minmax(0, 1fr)" : "minmax(0, 1fr)"};
  margin: 24px 0 16px;
  dt { color: ${COLORS.Gunmetal}; font-size: ${FONT_SIZE.fix16}; margin-bottom: 12px; }
  dd { margin: 0; }
`;
export const SummaryField = styled.div`
  min-width: 0;
  padding-right: 16px;
  & + & { border-left: 1px solid ${COLORS.lineColor}; padding-left: 20px; padding-right: 0; }
  @media (max-width: 400px) {
    padding-right: 10px;
    & + & { padding-left: 12px; }
  }
`;
export const StatusBadge = styled.span<{ $tone?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 16px;
  font-size: ${FONT_SIZE.fix14};
  font-weight: ${FONT_WEIGHT.semiBold};
  line-height: 1.4;
  color: ${({ $tone }) => $tone === "nonfunctional" ? COLORS.Crimson : COLORS.RaisinBlack};
  background: ${({ $tone }) => $tone === "partial" ? `${COLORS.Yellow}33` : $tone === "nonfunctional" ? `${COLORS.Crimson}15` : COLORS.Background};
  svg { flex-shrink: 0; }
`;
export const CapacityValue = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 6px;
  line-height: 1.25;
  strong { font-size: ${FONT_SIZE.max32}; font-weight: ${FONT_WEIGHT.bold}; }
  span { font-size: ${FONT_SIZE.fix16}; }
`;
export const DetailsList = styled.dl`
  margin: 0;
`;
export const DetailRow = styled.div<{ $emphasized: boolean }>`
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid ${COLORS.lineColor};
  line-height: 1.6;
  font-size: ${FONT_SIZE.fix16};
  dt { color: ${COLORS.Gunmetal}; }
  dd { margin: 0; overflow-wrap: anywhere; font-weight: ${({ $emphasized }) => $emphasized ? FONT_WEIGHT.semiBold : FONT_WEIGHT.regular}; }
  @media (max-width: 400px) { grid-template-columns: 84px minmax(0, 1fr); gap: 12px; }
`;
